module.exports = __webpack_public_path__ + "img/5.7379b6ca.png";